<template>
	<transition appear name="load">
		<div class="loading">
			<svg
				version="1.1"
				xmlns="http://www.w3.org/2000/svg"
				xmlns:xlink="http://www.w3.org/1999/xlink"
				x="0px"
				y="0px"
				width="30px"
				height="15px"
				viewBox="0 0 30 3"
				style="overflow: visible; enable-background: new 0 0 15 15"
				xml:space="preserve"
			>
				<defs />
				<ellipse
					class="dot"
					:fill="color"
					cx="5"
					cy="2.5"
					rx="3"
					ry="3"
				>
					<animate
						attributeName="ry"
						values="3; 3; 2; 3; 3;"
						keyTimes="0; 0.2; 0.3; 0.4; 1"
						dur="1.5s"
						begin="0s"
						repeatCount="indefinite"
					/>
					<animate
						attributeName="rx"
						values="3; 3; 4; 3; 3;"
						keyTimes="0; 0.2; 0.3; 0.4; 1"
						dur="1.5s"
						begin="0s"
						repeatCount="indefinite"
					/>
					<animate
						attributeName="cy"
						values="2.5; -2.5; 4; 2.5; 2.5;"
						keyTimes="0; 0.15; 0.3; 0.4; 1"
						dur="1.5s"
						begin="0s"
						repeatCount="indefinite"
					/>
				</ellipse>

				<ellipse
					class="dot"
					:fill="color"
					cx="15"
					cy="2.5"
					rx="3"
					ry="3"
				>
					<animate
						attributeName="ry"
						values="3; 3; 2; 3; 3;"
						keyTimes="0; 0.25; 0.35; 0.45; 1"
						dur="1.5s"
						begin=".5s"
						repeatCount="indefinite"
					/>
					<animate
						attributeName="rx"
						values="3; 3; 4; 3; 3;"
						keyTimes="0; 0.25; 0.35; 0.45; 1"
						dur="1.5s"
						begin=".5s"
						repeatCount="indefinite"
					/>
					<animate
						attributeName="cy"
						values="2.5; -2.5; 4; 2.5; 2.5;"
						keyTimes="0; 0.15; 0.3; 0.4; 1"
						dur="1.5s"
						begin=".5s"
						repeatCount="indefinite"
					/>
				</ellipse>
				<ellipse
					class="dot"
					:fill="color"
					cx="25"
					cy="2.5"
					rx="3"
					ry="3"
				>
					<animate
						attributeName="ry"
						values="3; 3; 2; 3; 3;"
						keyTimes="0; 0.25; 0.35; 0.45; 1"
						dur="1.5s"
						begin="1s"
						repeatCount="indefinite"
					/>
					<animate
						attributeName="rx"
						values="3; 3; 4; 3; 3;"
						keyTimes="0; 0.25; 0.35; 0.45; 1"
						dur="1.5s"
						begin="1s"
						repeatCount="indefinite"
					/>
					<animate
						attributeName="cy"
						values="2.5; -2.5; 4; 2.5; 2.5;"
						keyTimes="0; 0.15; 0.3; 0.4; 1"
						dur="1.5s"
						begin="1s"
						repeatCount="indefinite"
					/>
				</ellipse>
			</svg>
		</div>
	</transition>
</template>
<script>
	export default {
		props: {
			color: {
				type: String,
				default: '#a72b2a',
			},
		},
	}
</script>
<style lang="scss" scoped>
	.loading {
		svg {
			margin: auto 1px;
		}
	}
	.load-enter-active,
	.load-leave-active {
		transition: 0.3s ease all;
	}
	.load-enter-to,
	.load-leave {
		transition: 0.3s ease all;
		opacity: 1;
	}
	.load-enter,
	.load-leave-to {
		transition: 0.3s ease all;
		opacity: 0;
	}
</style>
